import React, { useEffect, useState } from "react";
import LeaveComp from "../leaveComponents/leave.comp";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import DashboardCard from "../../../component/dashboardCard";
import { CheckBox } from "@mui/icons-material";
import LeaveManagement from "../leaveComponents/leave.management";
import { getLeaveSummary } from "../../../api/leaves";
import { handleAxiosError } from "../../../config/action-config";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

export default function LeaveDashboardByEmpId() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [leaveSummaryData, setLeaveSummaryData] = useState({});

  async function leaveSummary() {
    try {
      const { data } = await getLeaveSummary(
        { employee_id: params.id },
        user.token
      );
      setLeaveSummaryData(data.data);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  useEffect(() => {
    if (user.token) {
      leaveSummary();
    }
  }, []);
  return (
    <div className="container-dash">
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Box className="pmt-title-box">
          <Box className="typography-title">
            <Typography variant="h1" className="pmt-headings-h1">
              Leave Distribution
            </Typography>
          </Box>

          <Box
            sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
          >
            <Button
              variant="contained"
              sx={{
                padding: "5px 7px",
                fontSize: { xs: "10px", sm: "12px" },
                marginRight: "10px",
              }}
              onClick={() => {
                navigate("/team-leaves");
              }}
              className="blue-button"
            >
              Go Back
            </Button>
          </Box>
        </Box>
        <br />
        <Grid container spacing={1}>
          {/* <Grid item xs={12}>
            <Typography variant="h6" color="textSecondary">
              Leave Distribution
            </Typography>
          </Grid> */}
          <Grid item xs={12} sm={3} md={3}>
            <Box className="card-radious card-inventory-1">
              <DashboardCard
                total={leaveSummaryData.total}
                tittle={"Total Leave"}
              >
                <CheckBox
                  sx={{ fontSize: 40 }}
                  // className="mui-icon yellow-bkg"
                  className="mui-icon"
                />
              </DashboardCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Box className="card-radious card-inventory-2">
              <DashboardCard
                total={leaveSummaryData.totalSickLeaves}
                tittle={"Sick Leave"}
              >
                <CheckBox className="mui-icon" />
              </DashboardCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Box className="card-radious card-inventory-2">
              <DashboardCard
                total={leaveSummaryData.totalCasualLeaves}
                tittle={"Casual Leave"}
              >
                <CheckBox className="mui-icon" />
              </DashboardCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Box className="card-radious card-inventory-1">
              <DashboardCard
                total={leaveSummaryData.totalPrivilegeLeaves}
                tittle={"Privilege Leave"}
              >
                <CheckBox
                  sx={{ fontSize: 40 }}
                  // className="mui-icon yellow-bkg"
                  className="mui-icon"
                />
              </DashboardCard>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" color="textSecondary">
            Left Leave
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <LeaveComp.LeftLeave
            text={"Total Leave"}
            Num={leaveSummaryData.leftTotalLeaves}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <LeaveComp.LeftLeave
            text={"Casual Leave"}
            Num={leaveSummaryData.leftCasualLeaves}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <LeaveComp.LeftLeave
            text={"Sick Leave"}
            Num={leaveSummaryData.leftSickLeaves}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <LeaveComp.LeftLeave
            text={"Privilege Leave"}
            Num={leaveSummaryData.leftPrivilegeLeaves}
          />
        </Grid>
      </Grid>
    </div>
  );
}
{
}
